<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pXtP8Q/tc-custom/9781504049658.jpg?1697135573431" alt="This image is the cover for the book Albert Samson Mysteries Volume One, The Albert Samson Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Albert Samson Mysteries Volume One, The Albert Samson Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A trio of thrilling cases for the Indianapolis private eye from the “fast, funny, and brilliant” three-time Edgar Award finalist (<i>Wall Street Journal</i>).</b><br/><br/> Michael Lewin “has brains and style”—and so does his Indy gumshoe, Albert Samson, so relaxed he doesn’t even carry a gun. In these three mysteries collected in one volume, Samson uses his wits to solve some very seedy crimes (<i>Los Angeles Times</i>).<br/>  <br/><i>Ask the Right Question</i>: Private investigator Albert Samson gets a shake-up with his new client: sixteen-year-old Eloise Crystal is desperate to find her biological father. What the detective unearths is the kind of dirt that makes people do desperate things. Thrust into a moneyed clan of old secrets and killer deceptions, Samson discovers that the first lie may be Eloise’s.<br/>  <br/><i>The Way We Die Now</i>: When Vietnam veteran Ralph Tomanek is charged with manslaughter, Samson believes there’s more to the story. But why was a man with a history of PTSD hired as an armed guard in the first place? The answer is a dizzying case of blackmail that lands Samson on the wrong end of the gun.<br/>  <br/><i>The Enemies Within</i>: Samson’s new client is Bennett Willson, a struggling writer looking for justice. It’s a pretty glitzy case for the cheapest detective in Indianapolis: Strong-arm a big-time Broadway producer who allegedly stole Willson’s play. Unfortunately, Willson proves to be as pure as the Indianapolis slush. What he wants is revenge. For Samson, finding out why could mean the final curtain call.<br/>  <br/> The recipient of a Mystery Masters Award, a Raymond Chandler Society Award, and a Maltese Falcon Society Award, Michael Lewin, “writes with style and sensibility and wit . . . He can frighten the reader, too” (Ross Macdonald).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Z. Lewin
      </h2>
      
      <p class="authorDescription body article">Michael Z. Lewin is the award-winning author of many mystery novels, short stories, and radio plays. He is best known for two series set in and around his hometown of Indianapolis. Albert Samson is a wry, low-key private eye who neither beats people up nor owns a gun. Leroy Powder is an irascible Indy police lieutenant who repeatedly &ldquo;helps&rdquo; his colleagues to become better cops. Both character also appear in Lewin&rsquo;s short stories. The main characters from the two series and other Indianapolis titles often appear in lesser roles in other books.<BR /><BR /> Since 1971, Lewin has lived in England, currently in Bath, where his city center flat overlooks the nearby hills. It also overlooks the front doors of the Lunghi family detective agency, a newer series of novels and stories set in the historic city. Visit him online at www.MichaelZLewin.com for more information.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1beda175